import {
  Component,
  Input,
  SimpleChange,
  SimpleChanges,
  ViewChild
} from '@angular/core';

import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexTitleSubtitle,
  ApexStroke,
  ApexGrid,
  ApexAnnotations,
  ApexLegend,
  ApexMarkers
} from 'ng-apexcharts';

import { PALETTE_COLORS } from 'src/app/@amiga-pyme/utils/palette_colors';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  annotations: ApexAnnotations;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexXAxis;
  dataLabels: ApexDataLabels;
  grid: ApexGrid;
  labels: string[];
  stroke: ApexStroke;
  title: ApexTitleSubtitle;
  colors: string[];
  legend: ApexLegend;
  markers: ApexMarkers;
};

@Component({
  selector: 'ami-line-chart',
  templateUrl: './ami-line-chart.component.html'
})
export class AmiLineChartComponent {
  @Input() annotationSettings: any;
  @Input() dataSeries: any[];
  @Input() categories: string[];
  @Input() keys: string[] | undefined = undefined;
  @Input() x_title: string;
  @Input() y_title: string;
  @Input() formatter: () => string;
  @Input() chartTitle: string;

  @ViewChild('chart') chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  ngOnChanges(changes: SimpleChanges) {
    if (this.chartOptions !== undefined) {
      const changesData = changes?.dataSeries.currentValue;
      if (changesData) {
        this.chartOptions.series = changes?.dataSeries.currentValue;
      }
    }
  }

  ngOnInit() {
    this.configureSettings();
  }

  configureSettings() {
    this.chartOptions = {
      annotations:
        this.annotationSettings !== undefined
          ? {
              xaxis: this.annotationSettings['xaxis'].map((el) => {
                return {
                  x: el['axisLabel'],
                  strokeDashArray: 0,
                  borderColor: '#775DD0',
                  label: {
                    borderColor: '#775DD0',
                    style: {
                      color: '#fff',
                      background: '#775DD0'
                    },
                    text: el['annoText']
                  }
                };
              })
            }
          : undefined,

      series: [...this.dataSeries],
      chart: {
        height: 350,
        type: 'line',
        dropShadow: {
          enabled: true,
          color: '#000',
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2
        },
        toolbar: {
          show: true
        },
        zoom: {
          enabled: false
        }
      },
      colors: PALETTE_COLORS.slice(0, this.dataSeries.length),
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'straight'
      },
      title: {
        text: this.chartTitle,
        align: 'left'
      },
      grid: {
        borderColor: '#e7e7e7',
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5
        }
      },
      markers: {
        size: 6,
        hover: {
          size: 10
        }
      },
      xaxis: {
        categories: this.categories,
        title: {
          text: this.x_title,
          style: {
            fontSize: '100%'
          }
        }
      },
      yaxis: {
        title: {
          text: this.y_title,
          style: {
            fontSize: '100%'
          }
        },
        labels: {
          formatter: this.formatter
        }
      },
      legend: {
        showForSingleSeries: true,
        fontSize: '15%',
        position: 'bottom',
        horizontalAlign: 'center',
        itemMargin: {
          horizontal: 5,
          vertical: 5
        }
      }
    };
  }
}
